import type { Phase } from '../game/stateMachine';

export interface ReplayTarget {
  readonly round: number;
  /** Le perdant (ou celui qui a disparu du cadre) : moi ou mon ami. */
  readonly who: 'me' | 'them';
}

/** Quel ralenti afficher dans cette phase ? `null` : aucun. */
export function replayTarget(phase: Phase, round: number): ReplayTarget | null {
  if (phase.name === 'review') return { round, who: phase.lostFace };
  if (phase.name !== 'result') return null;
  if (phase.outcome === 'won') return { round, who: 'them' };
  if (phase.outcome === 'lost') return { round, who: 'me' };
  return null;
}
